import type { AuthProviders } from 'core/app/types'
import routes from 'core/modules/router'
import SocialSignIn from 'pages/Unauthenticated/SocialSignIn'
import { useParams, useRouteMatch } from 'react-router-dom'
import { i18n } from 'translate/i18n'
import MetamaskView from 'components/Metamask'
type RouterParams = {
  provider: AuthProviders
}

const ConnectLogic = () => {
  const { provider } = useParams<RouterParams>()
  const isSignUp = useRouteMatch(routes.unauthenticated.signUp)
  const isSignIn = useRouteMatch(routes.unauthenticated.signIn)
  switch (provider) {
    case 'firebase':
    default:
      if (isSignUp) {
        return (
          <SocialSignIn
            type='sign-up'
            heading={i18n.t('unauthenticated.connect.createAccount')}
          />
        )
      } else if (isSignIn) {
        return (
          <SocialSignIn
            type='sign-in'
            heading={i18n.t('unauthenticated.connect.login')}
          />
        )
      }
      break
  }
  return null
}

export default ConnectLogic
